export default function generatePreviewUrl(id: string) : string {
  if (!id) {
    return null;
  }

  const { REACT_APP_VAULT_API_URL } = process.env;
  const url = `${REACT_APP_VAULT_API_URL}/media/${id}`;
  return url;
}
